// extracted by mini-css-extract-plugin
export default {"blockLabel":"block-label_blockLabel__nyYNl","infoButton":"block-label_infoButton__V+Agj","hiddenInPrint":"block-label_hiddenInPrint__YC5RT"};